<template>
  <v-container
    fluid
    pa-0
  >
    <v-row>
      <v-col
        class="text-center"
        cols="12"
      >
        <div
          class="d-inline-block text-left"
          style="width:100%; max-width: 560px"
        >
          <h2 class="brand-text-heading">
            {{ pageTitle.toLocaleUpperCase($i18n.locale) }}
          </h2>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-if="pageContent"
        class="text-center"
        cols="12"
      >
        <div
          v-safe-html="pageContent"
          class="d-inline-block text-justify"
          style="width:100%; max-width: 560px"
        />
      </v-col>

      <v-col
        class="text-center"
        cols="12"
      >
        <div
          class="d-inline-block text-justify"
          style="width:100%; max-width: 560px"
        >
          <v-form
            v-if="model"
            ref="form"
            v-model="isFormValid"
          >
            <v-container
              fluid
              pa-0
            >
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="model.Firstname"
                    :disabled="userIsAuthenticated"
                    :error-messages="serverErrorMessages['Firstname']"
                    :hint="$t('Page.PageContact.Field.Firstname.Hint')"
                    :label="$t('Page.PageContact.Field.Firstname.Label')"
                    :placeholder="$t('Page.PageContact.Field.Firstname.Placeholder')"
                    :rules="model.validator.vuetifyFormFieldRules('Firstname')"
                    autocomplete="given-name"
                    clearable
                    color="brand-green-dark"
                    flat
                    min="2"
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="model.Lastname"
                    :disabled="userIsAuthenticated"
                    :error-messages="serverErrorMessages['Lastname']"
                    :hint="$t('Page.PageContact.Field.Lastname.Hint')"
                    :label="$t('Page.PageContact.Field.Lastname.Label')"
                    :placeholder="$t('Page.PageContact.Field.Lastname.Placeholder')"
                    :rules="model.validator.vuetifyFormFieldRules('Lastname')"
                    autocomplete="family-name"
                    clearable
                    color="brand-green-dark"
                    flat
                    min="2"
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="model.Email"
                    :disabled="userIsAuthenticated"
                    :error-messages="serverErrorMessages['Email']"
                    :hint="$t('Page.PageContact.Field.Email.Hint')"
                    :label="$t('Page.PageContact.Field.Email.Label')"
                    :placeholder="$t('Page.PageContact.Field.Email.Placeholder')"
                    :rules="model.validator.vuetifyFormFieldRules('Email')"
                    autocomplete="email"
                    clearable
                    color="brand-green-dark"
                    flat
                    outlined
                    type="email"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="model.Phone"
                    v-mask="'##############'"
                    :disabled="userIsAuthenticated"
                    :error-messages="serverErrorMessages['Phone']"
                    :hint="$t('Page.PageContact.Field.Phone.Hint')"
                    :label="$t('Page.PageContact.Field.Phone.Label')"
                    :placeholder="$t('Page.PageContact.Field.Phone.Placeholder')"
                    :rules="model.validator.vuetifyFormFieldRules('Phone')"
                    autocomplete="mobile phone"
                    clearable
                    color="brand-green-dark"
                    flat
                    outlined
                    type="tel"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="model.Comments"
                    :error-messages="serverErrorMessages['Comments']"
                    :hint="$t('Page.PageContact.Field.Comments.Hint')"
                    :label="$t('Page.PageContact.Field.Comments.Label')"
                    :placeholder="$t('Page.PageContact.Field.Comments.Placeholder')"
                    :rules="model.validator.vuetifyFormFieldRules('Comments')"
                    auto-grow
                    color="brand-green-dark"
                    outlined
                    rows="5"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-checkbox
                    v-model="model.TermsCondition"
                    :error-messages="serverErrorMessages['TermsCondition']"
                    :rules="model.validator.vuetifyFormFieldRules('TermsCondition')"
                    :value="true"
                    class="mt-0"
                    color="brand-green-dark"
                    name="TermsCondition"
                    required
                  >
                    <template #label>
                      <div>
                        {{ $t('Auth.RegisterDialog.Field.TermsCondition.Label') }}
                        <template v-for="(link, index) in $t('Auth.RegisterDialog.Field.TermsCondition.Links')">
                          <div
                            :key="`link-${index}`"
                            class="d-inline-block"
                          >
                            <a
                              :href="link.Url"
                              class="d-inline-block"
                              target="_blank"
                              @click.stop
                            >
                              {{ link.Title }}
                            </a>

                            <div
                              v-if="$t('Auth.RegisterDialog.Field.TermsCondition.Links').length > 0 && index < $t('Auth.RegisterDialog.Field.TermsCondition.Links').length - 1"
                              class="d-inline-block"
                            >
                              &nbsp;{{ $t('Auth.RegisterDialog.Field.TermsCondition.And') }}&nbsp;
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-btn
                    :disabled="!isFormValid || isFormSaving"
                    :large="$vuetify.breakpoint.xsOnly"
                    :loading="isFormSaving"
                    :x-large="$vuetify.breakpoint.smAndUp"
                    block
                    class="text-capitalize brand-green-dark--text"
                    color="brand-primary"
                    depressed
                    @click="onContactClick"
                  >
                    <span class="brand-text-heading">{{ $t('Common.Button.Send').toLocaleUpperCase($i18n.locale) }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageContactMixin from '@/theme/default/views/pages/PageContact.js'

export default {
  name  : 'PageContact',
  mixins: [PageContactMixin]
}
</script>

<style scoped src="@/theme/default/views/pages/PageContact.css"></style>
<style scoped>
</style>
